/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Group from "vux/src/components/group/index.vue";
import XInput from "vux/src/components/x-input/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
import CheckIcon from "vux/src/components/check-icon/index.vue";
import Datetime from "vux/src/components/datetime/index.vue";
import FormMobile from '@/components/Base/FormMobile';
import SinglePicker from '@/components/Base/SinglePicker';
import { mapState } from 'vuex';
import { hdprojectproductInfo, hdOrderAddbymobilePhone } from '@/api';
import SmyMapAddress from '@/components/CustomFormList/SmyMapAddress';
import ImgUpload from '@/components/ImgUpload';
import FileUpload from './FileUpload';
import ImgUploadInput from '@/components/ImgUploadInput';
import CheckProject from '@/components/CheckProject';
import ManualInput from './ManualInput';
import CheckEquipment from '@/components/CheckEquipment';
export default {
  name: 'Accept',
  components: {
    FormMobile: FormMobile,
    Group: Group,
    XInput: XInput,
    SinglePicker: SinglePicker,
    XButton: XButton,
    CheckIcon: CheckIcon,
    Datetime: Datetime,
    SmyMapAddress: SmyMapAddress,
    ImgUpload: ImgUpload,
    FileUpload: FileUpload,
    CheckProject: CheckProject,
    ManualInput: ManualInput,
    CheckEquipment: CheckEquipment,
    ImgUploadInput: ImgUploadInput
  },
  computed: _objectSpread(_objectSpread({}, mapState('global', ['orderType'])), mapState('globalStore', ['user'])),
  data: function data() {
    return {
      project_id: '',
      hdProducts: [],
      form: {
        hdProducts: [],
        hdEntryProducts: [],
        objectFiles: [],
        imgList: [],
        videoList: [],
        project_name: '',
        contract_no: ''
      },
      rules: {
        title: {
          required: true,
          message: '标题必填'
        },
        // contract_no: { required: true, message: '项目号必填' },
        service_type: {
          required: true,
          message: '服务类型必填'
        },
        service_content: {
          required: true,
          message: '服务内容必填'
        },
        askfor_arrival_time: {
          required: true,
          message: '要求到岗时间必填'
        },
        askfor_completion_time: {
          required: true,
          message: '要求完成时间必填'
        },
        customer_name: {
          required: true,
          message: '客户身份必填'
        },
        customer_phone: {
          required: true,
          message: '客户电话必填'
        },
        area: {
          required: true,
          message: '区域必填'
        },
        detailed_address: {
          required: true,
          message: '详细地址必填'
        }
      },
      headList: ['操作', '产品类型', '出厂编号', '设备名称'],
      defaultCode: [],
      customLatitude: '',
      customLongitude: '',
      addressType: '',
      onlyCamera: true,
      isShowCheckProject: false,
      showManualInput: false,
      isShowCheckEquipment: false,
      oid: '',
      bol: false,
      id: localStorage.getItem('id')
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    submit: function submit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var form, form1, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.hdProducts;

              case 2:
                _this.form.hdProducts = _context.sent;

                if (_this.form.area == undefined) {
                  _this.form.area = _this.form.sales_regions;
                }

                console.log(222, _this.form);
                _context.next = 7;
                return _this.$refs.form.validate();

              case 7:
                form = _context.sent;
                _context.next = 10;
                return _this.$refs.form1.validate();

              case 10:
                form1 = _context.sent;

                if (!(!form || !form1)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", _this.$vux.toast.text('请输入完整信息'));

              case 13:
                _this.bol = true;
                _this.form.objectFiles = [].concat(_toConsumableArray(_this.form.imgList), _toConsumableArray(_this.form.videoList));
                _context.next = 17;
                return hdOrderAddbymobilePhone(_this.form);

              case 17:
                res = _context.sent;
                setTimeout(function () {
                  _this.bol = false;
                }, 500);

                if (res.data.success) {
                  _this.$vux.toast.text('提交成功');

                  _this.$router.go(-1);
                } else {
                  _this.$vux.toast.text(res.data.message);
                }

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getList: function getList(e) {
      e.map(function (val) {
        return val.product_name = val.name, val.fk_t_hd_project_production_id = val.value, val.id = val.value;
      });
      console.log(11, e);

      for (var i = 0; i < this.hdProducts.length; i++) {
        for (var o = 0; o < e.length; o++) {
          if (this.hdProducts[i].fk_t_hd_project_production_id == e[o].fk_t_hd_project_production_id) {
            e.splice(o, 1);
          }
        }
      }

      this.hdProducts = this.hdProducts.concat(JSON.parse(JSON.stringify(e)));
    },
    getItem: function getItem(e) {
      this.form.project_name = e.name;
      this.form.contract_no = e.contract_no;
      this.form.fk_t_hd_project_id = e.id;
      this.isShowCheckProject = false;
    },
    selectAddress: function selectAddress(e) {
      if (e.name.length) {
        var address = '';
        e.name.map(function (val) {
          address += val;
        });
        this.form.prov_id = e.code[0] || '';
        this.form.city_id = e.code[1] || '';
        this.form.district_id = e.code[2] || '';
        this.form.street_id = e.code[3] || '';
        this.form.area = address;
      } else {
        this.form.area = e.address;
      }

      this.customLongitude = e.longitude;
      this.customLatitude = e.latitude;
      this.defaultCode = e.code;
    },
    init: function init() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return hdprojectproductInfo(_this2.id);

              case 2:
                res = _context2.sent;

                if (res.data.code === 0) {
                  _this2.form = res.data.hdProjectProduct;
                  _this2.project_id = res.data.hdProjectProduct.project_id;
                  console.log(_this2.project_id);
                  _this2.form.hdProducts ? _this2.form.hdProducts : _this2.form.hdProducts = [];
                } else {
                  _this2.$vux.toast.text(res.msg);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    isShowCheckEquipment1: function isShowCheckEquipment1() {
      this.isShowCheckEquipment = true;
      this.$refs.CheckEquipment.loadList(true);
    },
    shanchu: function shanchu(index) {
      this.hdProducts.splice(index, 1);
    }
  }
};